//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { CreatorsBasicInfo } from '@models/CreatorsTypes';
import { SliceNames } from '@redux/SliceNames';

const initialState: { selectedCreators: Partial<CreatorsBasicInfo>[] } = {
  selectedCreators: [],
};

const { actions, reducer: CreatorsCampaignPaymentMembers } = createSlice({
  name: SliceNames.CreatorsCampaignPaymentMembers,
  initialState,
  reducers: {
    addPaymentCreatorsToSelection(
      state,
      { payload: creators }: PayloadAction<Partial<CreatorsBasicInfo>[]>,
    ) {
      state.selectedCreators = [
        ...state.selectedCreators,
        ...creators.filter(
          (newCreator) =>
            !state.selectedCreators.some(
              (existingCreator) =>
                existingCreator.id === newCreator.id &&
                existingCreator.network === newCreator.network,
            ),
        ),
      ];
    },
    clearPaymentCreatorsSelection(state) {
      state.selectedCreators = [];
    },
  },
});

export const { addPaymentCreatorsToSelection, clearPaymentCreatorsSelection } =
  actions;

export { CreatorsCampaignPaymentMembers };
